module.exports = __webpack_public_path__ + "img/emotion-design.7fcd9ef.webp";